
import Vue from 'vue'

export default Vue.extend({
   name: 'EmailAddressSection',
   props: {
      emailAddress: { type: String, default: '' },
      emailAddressImage: { type: String, default: '' },
   },
   computed: {
      isVisible(): boolean {
         return !!this.emailAddress
      },
   },
})
